import { createContext, useContext, useState, useCallback } from "react";

const QuoteCtx = createContext(null);

export const QuoteProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [preselectedService, setPreselectedService] = useState("");

  const openQuote = useCallback((service = "") => {
    setPreselectedService(service);
    setOpen(true);
  }, []);

  const closeQuote = useCallback(() => setOpen(false), []);

  return (
    <QuoteCtx.Provider value={{ open, openQuote, closeQuote, preselectedService }}>
      {children}
    </QuoteCtx.Provider>
  );
};

export const useQuote = () => {
  const ctx = useContext(QuoteCtx);
  if (!ctx) throw new Error("useQuote must be used within QuoteProvider");
  return ctx;
};
